import { jsx as _jsx } from "react/jsx-runtime";
import { useId, useMemo } from 'react';
import { CollapseContent } from '@jetbrains/ring-ui/components/collapse/collapse-content';
import { CollapseContext } from '@jetbrains/ring-ui/components/collapse/collapse-context';
import { BASE_ANIMATION_DURATION } from '@jetbrains/ring-ui/components/collapse/consts';
import { noop } from 'lodash';
export function Collapsible(props) {
    const { collapsed, children, disableAnimation = false, minHeight } = props;
    const id = useId();
    const contextValue = useMemo(() => ({
        id,
        collapsed,
        disableAnimation,
        setCollapsed: noop,
        duration: BASE_ANIMATION_DURATION
    }), [collapsed, disableAnimation, id]);
    return (_jsx(CollapseContext.Provider, { value: contextValue, children: _jsx(CollapseContent, { minHeight: minHeight, children: children }) }));
}
